
<div class="main-wrapper">
    <div class="row">
        <div class="col-12">
            <div class="max-w-7xl mx-auto pt-2 px-[1rem] inner-wrapper">
                <div class="flex items-center justify-between w-full">
                    <div
                        class="flex items-start justify-between w-full mt-4"
                          >
                          
                        <!-- Step 1 -->
                        <div
                            class="flex flex-col items-center"
                        >
                            <div
                                [ngClass]="{
                                    'w-16 h-16 rounded-full flex items-center justify-center transition-all': true,
                                    'bg-blue-600 text-white group-hover:ring-4 group-hover:ring-blue-100':
                                        step >= 1,
                                    'border-2 border-gray-300 text-gray-400': step < 1
                                }"
                            >
                                <!-- Step 1 Icon -->
                                <svg
                                    class="lucide lucide-building"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <rect
                                        width="16"
                                        height="20"
                                        x="4"
                                        y="2"
                                        rx="2"
                                        ry="2"
                                    ></rect>
                                    <path d="M9 22v-4h6v4"></path>
                                    <path d="M8 6h.01"></path>
                                    <path d="M16 6h.01"></path>
                                    <path d="M12 6h.01"></path>
                                    <path d="M12 10h.01"></path>
                                    <path d="M12 14h.01"></path>
                                    <path d="M16 10h.01"></path>
                                    <path d="M16 14h.01"></path>
                                    <path d="M8 10h.01"></path>
                                    <path d="M8 14h.01"></path>
                                </svg>
                            </div>
                            <span
                                [ngClass]="{
                                    'text-blue-600': step >= 1,
                                    'text-gray-400': step < 1
                                }"
                                class="mt-2 text-sm font-medium"
                            >
                                {{ "create-assignment.service" | translate }}</span
                            >
                        </div>
            
                        <!-- Step 2 -->
                        <div
                            class="flex flex-col items-center"
                        >
                            <div
                                [ngClass]="{
                                    'w-16 h-16 rounded-full flex items-center justify-center transition-all': true,
                                    'bg-blue-600 text-white': step >= 2,
                                    'border-2 border-gray-300 text-gray-400': step < 2
                                }"
                            >
                                <!-- Step 2 Icon -->
                                <svg
                                    class="lucide lucide-user"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    >
                                    <path
                                        d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
                                    ></path>
                                    <circle cx="12" cy="7" r="4"></circle>
                                </svg>
                            </div>
                            <span
                                [ngClass]="{
                                    'text-blue-600': step >= 2,
                                    'text-gray-400': step < 2
                                }"
                                class="mt-2 text-sm font-medium"
                            >
                                {{ "create-assignment.staff" | translate }}</span
                            >
                        </div>
            
                        <!-- Step 3 -->
                        <div
                            class="flex flex-col items-center"
                        >
                            <div
                                [ngClass]="{
                                    'w-16 h-16 rounded-full flex items-center justify-center transition-all': true,
                                    'bg-blue-600 text-white': step >= 3,
                                    'border-2 border-gray-300 text-gray-400': step < 3
                                }"
                            >
                                <!-- Step 3 Icon -->
                                <svg
                                    class="lucide lucide-calendar"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path d="M8 2v4"></path>
                                    <path d="M16 2v4"></path>
                                    <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                                    <path d="M3 10h18"></path>
                                </svg>
                            </div>
                            <span
                                [ngClass]="{
                                    'text-blue-600': step >= 3,
                                    'text-gray-400': step < 3
                                }"
                                class="mt-2 text-sm font-medium"
                            >
                                {{ "create-assignment.schedule" | translate }}</span
                            >
                        </div>

                    </div>
                </div>
            </div>

            
            <div class="inner-wrapper">
                <div class="d-flex justify-content-between gap-1 mt-2">
                    <div class="d-flex justify-content-start gap-1" (click)="onBack()">
                        <div class="back">
                            <img src="/assets/img/back arrow.svg" alt="back-arrow" loading="lazy"/>
                            <p class="back-p" >
                                {{ "create-assignment.back" | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="save-close" (click)="onCloseForm()">
                        <p class="close-p">
                            {{ "createCompany.Cancel" | translate }}
                        </p>
                        <img src="/assets/img/Close  blue(1).svg" alt="close" loading="lazy"/>
                    </div>
                   </div>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>

